import InvoiceCrud from "../components/invoice/InvoiceCrud";

const InvoicesPage = () => {
  return <InvoiceCrud />;
};

export default InvoicesPage;
